import clsx from 'clsx';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { DescriptionOutlined, DataObjectOutlined } from '@mui/icons-material';

import { Icon, IconType } from '../../../../../common/icon';

type DocText = 'API documentation' | 'API guide';

const getIcon = (text: DocText): IconType | null => {
  if (text === 'API guide') {
    return DescriptionOutlined;
  }

  if (text === 'API documentation') {
    return DataObjectOutlined;
  }

  return null;
};

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    color: 'inherit',
    fontSize: '18px',
    marginRight: theme.spacing(1)
  },
  container: {
    color: theme.palette.primary.main,
    display: 'flex'
  },
  link: {
    color: 'inherit',
    marginLeft: '2px'
  }
}));

interface Props {
  href: string;
  text: DocText;
}

const DocLink = ({ href, text }: Props) => {
  const classes = useStyles();
  const icon = getIcon(text);

  return (
    <Box className={classes.container}>
      {icon ? <Icon className={clsx(classes.icon)} icon={icon} /> : null}
      <a className={classes.link} href={href} target="_blank" rel="noreferrer">
        {text}
      </a>
    </Box>
  );
};

export default DocLink;
